import { render, staticRenderFns } from "./ButtonStrongReverse.vue?vue&type=template&id=a8edd3d2&scoped=true&lang=pug&"
import script from "./ButtonStrongReverse.vue?vue&type=script&lang=ts&"
export * from "./ButtonStrongReverse.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonStrongReverse.vue?vue&type=style&index=0&id=a8edd3d2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8edd3d2",
  null
  
)

export default component.exports